import { RegisterClass } from "core/Misc/typeStore";
import { Quaternion, Vector3 } from "core/Maths/math.vector";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphBuildState } from "../rewardGraphBuildState";

export class RewardAxisAngleBlock extends RewardGraphNode {
    public constructor(name: string) {
        super(name);

        this.registerInput("axis", RewardGraphConnectionPointTypes.Vector3);
        this.registerInput("degrees", RewardGraphConnectionPointTypes.Float);

        this.registerOutput("rotation", RewardGraphConnectionPointTypes.Quat);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardAxisAngleBlock";
    }

    /**
     * Gets the left input component
     */
    public get axis(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the right input component
     */
    public get angle(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    /**
     * Gets the reward output component
     */
    public get rotation(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        let func: (state: RewardGraphBuildState) => any;

        if (!this.axis.isConnected || !this.angle.isConnected) {
            this.rotation._storedFunction = null;
            this.rotation._storedValue = null;
            return;
        }

        func = (state) => {
            const angle = (this.angle.getConnectedValue(state) * Math.PI) / 180;
            const axis = this.axis.getConnectedValue(state) as Vector3;
            const rotated = Quaternion.RotationAxis(axis, angle);
            return rotated;
        }

        this.rotation._storedFunction = (state) => {
            return func(state);
        };
    }
}

RegisterClass("MELS.RewardAxisAngleBlock", RewardAxisAngleBlock);
